const mapKeyColorStyle = {
  // width: '1em',
  // height: '1em',
  // borderRadius: '0.5em',
  // display: 'inline-block',
}


export default mapKeyColorStyle



// WEBPACK FOOTER //
// ./src/components/Visualizations/util/map-key-color-style.js